<template>
  <div class="online-compliance">
    <ComplianceFillIn
      :onlineCompliance="true"
      :firstName="firstName"
      :lastName="lastName"
      :id="userId"
      :entityId="entityId"
      :visitId="visitId"
      :siteName="siteName"
      :areaName="areaName"
      :userTypeForUser="userTypeForUser"
      :visitDate="visitDate"
      :visitTime="visitTime"
      :registrationMethod="registrationMethod"
      :journeyStage="journeyStage"
      :journeyLogo="journeyLogo"
      :entityLogo="entityLogo"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ComplianceFillIn from "@/components/dashboard/complianceFillIn";
export default {
  title: "Online Compliance",
  name: "onlineComplianceForm",
  components: {
    ComplianceFillIn,
  },
  data() {
    return {
      id: this.$route.params.id,
      firstName: null,
      lastName: null,
      siteName: null,
      areaName: null,
      userTypeForUser: null,
      visitDate: null,
      visitTime: null,
      userId: null,
      visitId: null,
      entityId: null,
      registrationMethod: null,
      journeyStage: null,
      journeyLogo: "",
      entityLogo: "",
    };
  },
  computed: {
    ...mapGetters("compliance", ["getComplianceCreated"]),
    ...mapGetters("i18N", ["getLanguage"]),
  },
  methods: {
    ...mapActions("compliance", ["fetchUserOnlineCompliance"]),
    fetchData() {
      this.fetchUserOnlineCompliance(this.id)
      .then((data) => {
        console.log('wee', data.data.data.data.journeyStage);
        this.firstName = data.data.data.data.firstName;
        this.lastName = data.data.data.data.lastName;
        this.siteName = data.data.data.data.siteName;
        this.areaName = data.data.data.data.areaName;
        this.userTypeForUser = data.data.data.data.userTypeName;
        this.visitDate = data.data.data.data.visitDate;
        this.visitTime = data.data.data.data.visitTime;
        this.userId = data.data.data.data.userId;
        this.visitId = data.data.data.data.visitId;
        this.entityId = data.data.data.data.entityId;
        this.usertypeId = data.data.data.data.usertypeId;
        this.registrationMethod = data.data.data.data.registrationMethod;
        this.journeyStage = data.data.data.data.journeyStage;
        this.journeyLogo = data.data.data.data.journeyLogo;
        this.entityLogo = data.data.data.data.entityLogo;
      })
      .catch((e) => console.log(e));
    }
  },
  watch: {
    getComplianceCreated(value) {
      console.log("watch online", value);
      this.fetchData();
    },
  },
  beforeMount() {
    this.fetchData();
    const html = document.documentElement;
    html.setAttribute("lang", this.getLanguage);
    html.setAttribute("dir", this.getLanguage === "ar" ? "rtl" : "ltr");
  },
};
</script>